export default from './Dropzone';



// WEBPACK FOOTER //
// ./src/sharedComponents/Dropzone/index.js